import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import "./styles/site.css";
import "./styles/gruvbox-overrides.css";
import "./styles/split-flap.css";

/** Mounts the portfolio application into the static HTML shell. */
function mountPortfolio(): void {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("The portfolio root element is missing from index.html.");
  }

  createRoot(rootElement).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}

mountPortfolio();
